export default "__VITE_ASSET__DbgxDiy5__"